var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('lord-icon',{staticClass:"anim",attrs:{"trigger":_vm.trigger,"src":_vm.src,"colors":_vm.colors}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }